module.exports = __webpack_public_path__ + "src/assets/img/google/google-gsuite-icon.a06298613a3986d8fb8337bb46797ac5.png";